export const SET_CALLCENTER_AGENT = "@LIVECHAT/SET_CALLCENTER_AGENT";
